// extracted by mini-css-extract-plugin
export var link = "_t5-0";